const I18N_BASE = 'ARDHISASA.LAND_PROCESSES.LAND_REGISTRATION';

// Field/section definitions per process_name. Sections only render when their
// backing data is actually present — see ProcessDetailPanel.vue.
export const LAND_PROCESS_DETAIL_CONFIG = {
  TRANSFER: {
    staticTitle: 'Interests Of Land Transfer',
    summaryFields: [
      { key: 'reference_number', labelKey: `${I18N_BASE}.REFERENCE_NUMBER` },
      { key: 'parcel_number', labelKey: `${I18N_BASE}.PARCEL_NUMBER` },
      { key: 'county', labelKey: `${I18N_BASE}.COUNTY` },
      {
        key: 'nature_of_interest_to_be_transferred',
        labelKey: `${I18N_BASE}.NATURE_OF_INTEREST`,
      },
      { key: 'type_of_property', labelKey: `${I18N_BASE}.TYPE_OF_PROPERTY` },
      {
        key: 'proprietors_holding_type',
        labelKey: `${I18N_BASE}.HOLDING_TYPE`,
      },
      { key: 'consideration', labelKey: `${I18N_BASE}.CONSIDERATION` },
      { key: 'date_created', labelKey: `${I18N_BASE}.CREATED`, format: 'date' },
      {
        key: 'submit_time',
        labelKey: `${I18N_BASE}.SUBMITTED`,
        format: 'date',
      },
    ],
    pills: [
      { key: 'title_submitted', labelKey: `${I18N_BASE}.TITLE_SUBMITTED` },
      { key: 'property_exists', labelKey: `${I18N_BASE}.PROPERTY_EXISTS` },
      {
        key: 'property_enumerated',
        labelKey: `${I18N_BASE}.PROPERTY_ENUMERATED`,
      },
      { key: 'exempt_stamp_duty', labelKey: `${I18N_BASE}.STAMP_DUTY_EXEMPT` },
    ],
    partyGroups: [
      {
        key: 'transferors',
        labelKey: `${I18N_BASE}.TRANSFERORS`,
        roleLabel: 'TRANSFEROR',
      },
      {
        key: 'transferees',
        labelKey: `${I18N_BASE}.TRANSFEREES`,
        roleLabel: 'TRANSFEREE',
      },
      {
        key: 'advocates',
        labelKey: `${I18N_BASE}.ADVOCATES`,
        roleLabel: 'ADVOCATE',
      },
    ],
    stampDuty: {
      statusKey: 'stamp_duty_status',
      applicationStatusKey: 'stamp_duty_application_status',
      sectionKey: 'stamp_duty_exemption_details.section',
      basisKey: 'stamp_duty_exemption_details.section_chapter_description',
    },
    people: [
      { key: 'applicant', labelKey: `${I18N_BASE}.APPLICANT` },
      { key: 'drawn_by', labelKey: `${I18N_BASE}.DRAWN_BY` },
      { key: 'pickup_person', labelKey: `${I18N_BASE}.PICKUP_PERSON` },
    ],
  },

  ENUMERATION: {
    staticTitle: 'Parcel Enumeration',
    summaryFields: [
      { key: 'reference_number', labelKey: `${I18N_BASE}.REFERENCE_NUMBER` },
      { key: 'parcel_number', labelKey: `${I18N_BASE}.PARCEL_NUMBER` },
      { key: 'county', labelKey: `${I18N_BASE}.COUNTY` },
      { key: 'nature_of_title', labelKey: `${I18N_BASE}.NATURE_OF_TITLE` },
      { key: 'holding_type', labelKey: `${I18N_BASE}.HOLDING_TYPE` },
      { key: 'share_type', labelKey: `${I18N_BASE}.SHARE_TYPE` },
      { key: 'date_created', labelKey: `${I18N_BASE}.CREATED`, format: 'date' },
    ],
    pills: [],
    partyGroups: [
      {
        key: 'parcel_owners',
        labelKey: `${I18N_BASE}.PARCEL_OWNERS`,
        roleLabel: 'OWNER',
      },
    ],
    stampDuty: null,
    people: [{ key: 'applicant', labelKey: `${I18N_BASE}.APPLICANT` }],
  },
};

export function detailConfigFor(processName) {
  return LAND_PROCESS_DETAIL_CONFIG[(processName || '').toUpperCase()] || null;
}
